import '../styles/heatmap-key.css';

export const HeatmapKey = () => {
  return (
    <div className='heatmap-key'>
      <div className='heatmap-key-title'>Heatmap Key</div>

      <div className='heatmap-key-items'>
        <div className='heatmap-key-item'>
          <span className='key-box red' />
          <span>Hazardous Impairment Likely</span>
        </div>

        <div className='heatmap-key-item'>
          <span className='key-box yellow' />
          <span>Elevated Impairment Likely</span>
        </div>

        <div className='heatmap-key-item'>
          <span className='key-box green' />
          <span>Good To Go</span>
        </div>

        <div className='heatmap-key-item'>
          <span className='key-box striped' />
          <span>Did Not Check In</span>
        </div>

        <div className='heatmap-key-item'>
          <span className='key-box grey' />
          <span>Baseline Creation In Progress</span>
        </div>
      </div>
    </div>
  );
};
